import React, { useContext } from 'react';
import { List } from '@sm/wds-react';

import { SubMenuItem } from '../components/SubMenuItem';
import SMHeaderContext from '../../../SMHeaderContext';

import {
  enterprise,
  audience,
  integrations,
  cx,
  engage,
  techValidate,
  wufoo,
  apply,
  usabilla,
  getFeedback,
} from '../../../config/MobileLinkInfo';

import {
  hasCX,
  hasEngage,
  hasTechValidate,
  hasWufoo,
  hasApply,
  hasUsabilla,
  hasGetFeedback,
} from '../../../../../helpers/languageHelpers.js';

export const ProductsMenu = () => {
  const { lang, isEUDC } = useContext(SMHeaderContext);
  return (
    <List transparent>
      <SubMenuItem {...enterprise()} />
      <SubMenuItem {...audience()} show={!isEUDC} />
      <SubMenuItem {...integrations()} />
      <SubMenuItem {...cx()} show={hasCX(lang)} />
      <SubMenuItem {...engage()} show={hasEngage(lang)} />
      <SubMenuItem {...techValidate()} show={hasTechValidate(lang)} />
      <SubMenuItem {...wufoo()} show={hasWufoo(lang)} />
      <SubMenuItem {...apply()} show={hasApply(lang)} />
      <SubMenuItem {...usabilla()} show={hasUsabilla(lang)} />
      <SubMenuItem {...getFeedback()} show={hasGetFeedback(lang)} />
    </List>
  );
};

export default ProductsMenu;
